import { render } from "./VerificationTab.vue?vue&type=template&id=8c49c7ce"
import script from "./VerificationTab.vue?vue&type=script&lang=js"
export * from "./VerificationTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__